import axios from 'axios'

// Send the Rails CSRF token with every API request made with the login
// cookie. The token is read per request because Turbolinks swaps the page
// head without reloading the packs.
axios.interceptors.request.use(config => {
  const meta = document.querySelector('meta[name="csrf-token"]')
  if (meta) {
    config.headers['X-CSRF-Token'] = meta.getAttribute('content')
  }
  return config
})
